import { CompendiumPanel } from '@labsavvyapp/components'
import { CompendiumPanelWithType } from '../types'

/**
 * This calculates the total retail price of all tests.
 * @param panels
 * @returns number
 */
export const calculateOrdersetPatientPrice = (panels: CompendiumPanel[] | CompendiumPanelWithType[]) => {
  if (!panels) {
    return 0
  }

  const retailPackagePrice = panels.map((test) => test.retail_price).reduce((sum, price) => sum + price, 0)

  return retailPackagePrice
}
